<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary" class="textwithbackground--text">
        <v-toolbar-title>
          {{ $t('Редактирование записи справочника') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col v-if="isLoading" cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col v-if="!!generalError" class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <ValidationObserver ref="item" @keydown.native.enter="focusOnBtn('continueBtn')">

          <validatable-text-input
              v-model="item.prepaymentPercentage"
              :readonly="isLoading"
              :label="$t('Размер предоплаты, %')"
              :rules="{ required: true,
                        min_value: 0,
                        max_value: 100,
                        regex: /^[0-9]{1,3}$/ }"
              data-type="float" />

        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="continueBtn"
            v-test="{ btn: 'continue' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'

  export default {
    components: {
      ValidatableTextInput,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            item: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        isLoading: false,
        item: {
          organizationId: null,
          prepaymentPercentage: null
        }
      }
    },
    created () {
      this.mapFields(this.dialogProp.item)
    },
    beforeDestroy () {
    },
    methods: {
      mapFields: function (item) {
        if (!item) {
          return
        }
        this.item.organizationId = item.organizationId
        this.item.prepaymentPercentage = item.prepaymentPercentage
      },
      continueOperation: async function () {
        try {
          const result = await this.$refs.item.validate()
          if (!result) {
            return
          }
          this.isLoading = true

          if (this.dialogProp.callback) {
            await this.dialogProp.callback({
              organizationId: this.item.organizationId,
              prepayment: { ...this.item }
            })
          }
          this.isLoading = false
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
          // проверка или сохранение формы неуспешно, остаемся в диалоговом окне
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
